/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsEFTExternalProviderViewModel } from './PaymentDetailsEFTExternalProviderViewModel';
import {
    PaymentDetailsEFTExternalProviderViewModelFromJSON,
    PaymentDetailsEFTExternalProviderViewModelFromJSONTyped,
    PaymentDetailsEFTExternalProviderViewModelToJSON,
} from './PaymentDetailsEFTExternalProviderViewModel';
import type { PaymentDetailsEFTPayerViewModel } from './PaymentDetailsEFTPayerViewModel';
import {
    PaymentDetailsEFTPayerViewModelFromJSON,
    PaymentDetailsEFTPayerViewModelFromJSONTyped,
    PaymentDetailsEFTPayerViewModelToJSON,
} from './PaymentDetailsEFTPayerViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsEFTViewModel
 */
export interface PaymentDetailsEFTViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsEFTViewModel
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsEFTViewModel
     */
    canHavePayers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsEFTViewModel
     */
    canHaveExternalPayers?: boolean;
    /**
     * 
     * @type {Array<PaymentDetailsEFTPayerViewModel>}
     * @memberof PaymentDetailsEFTViewModel
     */
    payers: Array<PaymentDetailsEFTPayerViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsEFTExternalProviderViewModel>}
     * @memberof PaymentDetailsEFTViewModel
     */
    externalProviders: Array<PaymentDetailsEFTExternalProviderViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsEFTViewModel interface.
 */
export function instanceOfPaymentDetailsEFTViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payers" in value;
    isInstance = isInstance && "externalProviders" in value;

    return isInstance;
}

export function PaymentDetailsEFTViewModelFromJSON(json: any): PaymentDetailsEFTViewModel {
    return PaymentDetailsEFTViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsEFTViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsEFTViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'canHavePayers': !exists(json, 'CanHavePayers') ? undefined : json['CanHavePayers'],
        'canHaveExternalPayers': !exists(json, 'CanHaveExternalPayers') ? undefined : json['CanHaveExternalPayers'],
        'payers': ((json['Payers'] as Array<any>).map(PaymentDetailsEFTPayerViewModelFromJSON)),
        'externalProviders': ((json['ExternalProviders'] as Array<any>).map(PaymentDetailsEFTExternalProviderViewModelFromJSON)),
    };
}

export function PaymentDetailsEFTViewModelToJSON(value?: PaymentDetailsEFTViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Amount': value.amount,
        'CanHavePayers': value.canHavePayers,
        'CanHaveExternalPayers': value.canHaveExternalPayers,
        'Payers': ((value.payers as Array<any>).map(PaymentDetailsEFTPayerViewModelToJSON)),
        'ExternalProviders': ((value.externalProviders as Array<any>).map(PaymentDetailsEFTExternalProviderViewModelToJSON)),
    };
}

